import { BehaviorSubject } from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthInnerRouterParams } from '../auth-form/auth-form.component';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { filter } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { digitsFaToEn } from '@persian-tools/persian-tools';
import {
  AuthStatusObject,
  checkPasswords,
  iranPhoneValidator,
  IsPersianValidator,
} from 'src/app/shared';
import { AuthService } from '../../services';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'auth-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  @Input('selected-index') selectedIndex!: number;
  @Input('landing-auth-sidenav') authSidenav!: MatSidenav;
  @Input('inner-router') innerRouter!: BehaviorSubject<AuthInnerRouterParams>;
  @Output('auth-event') onAuth: EventEmitter<AuthStatusObject> =
    new EventEmitter();

  @Output() loadingStart = new EventEmitter();
  @Output() stopLoading = new EventEmitter();

  public _checkingPhoneNumber: boolean = false;
  private subsink = new SubSink();
  referral = '';

  ngOnInit(): void {}
  ngAfterViewInit() {
    this.subsink.sink = this.phoneField.valueChanges
      .pipe(filter(() => this.phoneField.valid))
      .subscribe(this.checkPhoneExistence());
  }
  registerForm!: FormGroup;
  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe((res: any) => {
      if (res?.referral) this.referral = res?.referral;
    })
    this.registerForm = this.formBuilder.group({
      phone: [
        '',
        [
          Validators.minLength(11),
          Validators.maxLength(11),
          Validators.required,
          iranPhoneValidator,
        ],
      ],
      password: ['', [
        Validators.minLength(8),
        Validators.maxLength(64),
        Validators.required,
      ]],
      confirmPassword: ['', Validators.required],
      fullName: ['', [
        Validators.minLength(2),
        Validators.maxLength(64),
        Validators.required,
        IsPersianValidator,
      ]]
    });
  }

  // public registerForm: FormGroup = new FormGroup(
  //   {
  //     phone: new FormControl('', [
  //       Validators.minLength(11),
  //       Validators.maxLength(11),
  //       Validators.required,
  //       iranPhoneValidator,
  //     ]),

  //     password: new FormControl('', [
  //       Validators.minLength(8),
  //       Validators.maxLength(64),
  //       Validators.required,
  //     ]),

  //     confirmPassword: new FormControl('', [Validators.required]),

  //     fullName: new FormControl('', [
  //       Validators.minLength(2),
  //       Validators.maxLength(64),
  //       Validators.required,
  //       IsPersianValidator,
  //     ]),
  //   },
  //   { validators: checkPasswords }
  // );

  public get phoneField(): AbstractControl {
    return this.registerForm.get('phone') as AbstractControl;
  }

  public get passwordField(): AbstractControl {
    return this.registerForm.get('password') as AbstractControl;
  }

  public get confirmPassword(): AbstractControl {
    return this.registerForm.get('confirmPassword') as AbstractControl;
  }

  public get fullNameField(): AbstractControl {
    return this.registerForm.get('fullName') as AbstractControl;
  }

  checkRepeatPassword() {
    if (this.passwordField.value !== this.confirmPassword.value) {
      this.confirmPassword.setErrors({ confirmPass: true });
    } else {
      this.confirmPassword.setErrors(null);
    }
  }

  onSubmitRegister() {
    this.loadingStart.emit();

    const request = this.registerForm.value;
    if (this.referral) request.referral = this.referral;

    console.log(request);
    
    this.subsink.sink = this.authService
      .classicRegister(request)
      .subscribe(
        (authObject: AuthStatusObject) => {
          this.onAuth.emit(authObject);
          // this.toggleLogin();s
        },
        (error) => {}
      );
  }

  toggleLogin() {
    this.innerRouter.next('login');
  }

  checkPhoneExistence() {
    const parent = this;

    return (phoneNo: string) => {
      parent._checkingPhoneNumber = true;

      parent.subsink.sink = parent.authService
        .checkPhoneExistence(digitsFaToEn(phoneNo))
        .subscribe((result: any) => {
          if (!result)
            parent.phoneField.setErrors({ phoneExists: { valid: false } });

          // Turn loader off.
          setTimeout(() => {
            parent._checkingPhoneNumber = false;
          }, 700);
        });
    };
  }

  ngOnDestroy() {
    this.subsink.unsubscribe();
  }
}
